import { P, match } from '@frontend/duck-tape';
import type { DraftParentStepProps } from '@frontend/react-domain';
import { useInformationGatheringStep } from '@frontend/react-domain';
import { LoadingSpinnerPanel, YStack } from '@frontend/web-react';
import { InitialQuestions } from './InitialQuestions';

export const InformationGathering = ({ decrementParentStep, incrementParentStep }: DraftParentStepProps) => {
  const { changeInformationGatheringStep, currentStep, goToDescriptionStep } = useInformationGatheringStep({
    decrementParentStep,
    incrementParentStep,
  });

  return (
    <YStack className="grid grid-cols-1 lg:grid-cols-4 w-full px-md">
      <YStack className="col-start-1 lg:col-start-2 lg:col-span-2">
        {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
        <YStack className="w-full min-h-[60vh]" justifyContent="center">
          {match(currentStep)
            .with('initial_questions', () => (
              <InitialQuestions changeStep={changeInformationGatheringStep} goToDescriptionStep={goToDescriptionStep} />
            ))
            .with(P.nullish, () => (
              <YStack className="h-full">
                <LoadingSpinnerPanel />
              </YStack>
            ))
            .exhaustive()}
        </YStack>
      </YStack>
    </YStack>
  );
};
